module.exports = __webpack_public_path__ + "static/img/ojk.601623c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ojk.png
// module id = QX30
// module chunks = 36